import { Alert, Box, Snackbar, Button } from "@mui/material";
import {
  boostBtnBg,
  btnBg,
  btnBgTwo,
  dollorSign,
  maxBtnBg,
  thunder,
} from "./Images";

export function ToastNotify({ alertState, setAlertState }) {
  return (
    <Snackbar
      style={{ zIndex: "1500" }}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={alertState.open}
      autoHideDuration={10000}
      key={"top center"}
      onClose={() => setAlertState({ ...alertState, open: false })}
    >
      <Alert
        onClose={() => setAlertState({ ...alertState, open: false })}
        severity={alertState.severity}
      >
        {alertState.message}
      </Alert>
    </Snackbar>
  );
}

export function StyledButton({ children, ...props }) {
  return (
    <>
      <Box
        {...props}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: props.width,
          height: "40px",
          background:
            "linear-gradient(0deg, rgba(243,148,31,1) 50%, rgba(246,178,29,1) 50%)",
          border: "1px solid #000",
          borderRadius: "5px",
          boxShadow: "0px 4px #6D3B0C",
          cursor: "pointer",
          mt: props.mt,
          mx: props.mx,
        }}
      >
        {children}
      </Box>
    </>
  );
}

export function StyledNavButton({ children, ...props }) {
  return (
    <>
      <Button
        {...props}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: props.width,
          height: props?.height ? props?.height : "50px",
          background: props?.bgColor ? props?.bgColor : "#55CB01",
          boxShadow:
            "0px 12px 18.799999237060547px 0px #00000040,0px 4px 4px 0px #FFFFFF inset",
          cursor: "pointer",
          fontFamily: "Montserrat",
          color: "#FFFFFF",
          fontSize: "15px",
          borderRadius: "30px",
          textTransform: "capitalize",
          px: 1,
          mt: props.mt,
          mx: props.mx,
          "&:hover": {
            background: props?.bgColor ? props?.bgColor : "#55CB01",
          },
        }}
      >
        {children}
      </Button>
    </>
  );
}

export function StyledText({ children, ...props }) {
  return (
    <>
      <Box
        {...props}
        sx={{
          color: " #FFFFFF",
          fontSize: "18px",
          fontFamily: "Montserrat",
          fontWeight: "500",
          mr: props.mr,
        }}
      >
        {children}
      </Box>
    </>
  );
}
export function StyledTitle({ children, ...props }) {
  return (
    <>
      <Box
        {...props}
        sx={{
          color: "#000000",
          fontSize: "40px",
          //   fontFamily: "Josefin Sans",
          fontWeight: "700",
          mr: props.mr,
        }}
      >
        {children}
      </Box>
    </>
  );
}

export function StyledButtonTwo({ children, ...props }) {
  return (
    <>
      <Button
        disableRipple={true}
        {...props}
        startIcon={
          <Box
            component={"img"}
            alt={""}
            src={props?.btnStatus ? "" : dollorSign}
            width={props?.btnStatus ? "0px" : { xs: "20px", sm: "35px" }}
            ml={{ xs: props?.disabled ? 0 : -1.5, sm: -2.8 }}
            mr={{ xs: props?.disabled ? -0.8 : -0.4, sm: -0.3 }}
          />
        }
        sx={{
          color: "#ffffff",
          backgroundImage: `url(${
            props?.btnStatus
              ? boostBtnBg
              : props?.btnTwoStatus
              ? btnBgTwo
              : props?.disabled
              ? maxBtnBg
              : btnBg
          })`,
          backgroundSize: "100% 100%",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundColor: "transparent",
          justifyContent: "center",
          fontFamily: "Lilita One",
          fontSize: { xs: "14px", sm: "20px" },
          fontWeight: "400",
          WebkitTextStroke: "0.5px black",
          textShadow:
            "-0.8px -0.8px 0 #0B0A26, 0.8px -0.8px 0 #0B0A26, -0.8px 0.8px 0 #0B0A26, 0.8px 0.8px 0 #0B0A26",
          textTransform: "capitalize",
          width: props.width,
          height: props?.height ? props?.height : "60px",
          "&.Mui-disabled": {
            color: "#ffffff",
          },
        }}
      >
        {children}
      </Button>
    </>
  );
}
